import { render, staticRenderFns } from "./ChecklistPacote.vue?vue&type=template&id=6b84980a"
import script from "./ChecklistPacote.vue?vue&type=script&lang=js"
export * from "./ChecklistPacote.vue?vue&type=script&lang=js"
import style0 from "./ChecklistPacote.vue?vue&type=style&index=0&id=6b84980a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports